import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import * as $ from 'jquery';
import Swiper, { Navigation } from 'swiper';
import { Router} from '@angular/router';
import { Utility } from '../../shared/utility/utility';
import { EmitterService } from '../../services/emitter.service';
// import { homePageLobbyUrlNaming, liveCasinoPageLobbyUrlNaming } from "../../shared/utility/config";
import { takeUntil } from 'rxjs/operators';
import { combineLatest, Subject } from 'rxjs';

@Component({
  selector: 'app-lobby-swiper',
  templateUrl: './lobby-swiper.component.html',
  styleUrls: ['./lobby-swiper.component.scss']
})
export class LobbySwiperComponent implements OnInit, OnDestroy, OnChanges {
  destroy$: Subject<boolean> = new Subject();
  langCode
  instance_swiper: any;
  swiperButtonsCheck = false;
  lobbyNameString;
  @Input() disableViewMore = false;
  start = 0;
  end = 18;

  @Input() groupIndex;
  @Input() favItemObj;
  @Input() currentLobby;
  @Input() gameGroup;
  @Input() gameGroupDetails;
  @Input() liveTableData

  constructor(
    private router: Router,
    private utils: Utility,
    private emitterService: EmitterService
  ) { 
    this.langCode = localStorage.getItem('langCode');
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });
  }

  ngOnChanges(){
    setTimeout(() => {
      if (this.instance_swiper) {
        this.instance_swiper.update();
      }
    });
  }

  ngOnInit(): void {
    this.initializeSwiper();
    setTimeout(() => {
      this.swiperButtonsCheck = true;
    });
  }
  
  initializeSwiper() {
    this.lobbyNameString = ((this.gameGroup["name"]).replace(/[\s~`!@#$%^&*()_+\-={[}\]|\\:;"'<,>.?/]+/g, '_')).toLowerCase();
    setTimeout(() => {
      this.instance_swiper = new Swiper(('.lobby-swiper--' + this.lobbyNameString), {
        modules: [Navigation],
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 12,
        navigation: {
          prevEl: ".swiper-button-prev--" + this.lobbyNameString,
          nextEl: ".swiper-button-next--" + this.lobbyNameString
        },
        breakpoints: {
          0: {
            slidesPerView: 2.05,
            slidesPerGroup: 2,
            spaceBetween: 12
          },
          481: {
            slidesPerView: 2.05,
            slidesPerGroup: 2,
            spaceBetween: 12
          },
          768: {
            slidesPerView: 6,
            slidesPerGroup: 6,
            spaceBetween: 12
          },
          992: {
            slidesPerView: 6,
            slidesPerGroup: 6,
            spaceBetween: 18,
          },
          1024: {
            slidesPerView: 6,
            spaceBetween: 18,
          }
        }
      });
    });
  }

  goToCategory(gameGroup) {
    if(gameGroup && gameGroup.multilingualUrlGameGroup && gameGroup.multilingualUrlGameGroup[this.utils.getActualMappedLanguage(this.langCode)]){
      const gameGroupUrl = gameGroup.multilingualUrlGameGroup[this.utils.getActualMappedLanguage(this.langCode)];
      let lobbyName = this.currentLobby.multilingualUrlLobby[this.utils.getActualMappedLanguage(this.langCode)];
      if(lobbyName === this.utils.getActualMappedLanguage(this.langCode)){
        lobbyName = 'home';
      }

      return '/'+this.langCode + '/casino/' + lobbyName + '/' + gameGroupUrl;
    }
  }

  isToShowButtons() {
    if(this.swiperButtonsCheck) {
      if (!($(".lobby-header--"+this.lobbyNameString+ " .swiper-button-prev").hasClass("swiper-button-disabled") && $(".lobby-header--"+this.lobbyNameString+ " .swiper-button-next").hasClass("swiper-button-disabled"))) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
